<template>
    <div class="right_items">
        <div class="r_item" v-for="(item,index) in rightItems" :key="index" @click="routerLink(item)" @mouseover="rightItemsHover(index,true)" @mouseout="rightItemsHover(index,false)">
            
            <div class="text" v-show="item.show">
                {{item.name}}
            </div>
            <div class="icon">
                <i :class="item.iconClass"></i>
            </div>
            
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'pcbtns',
        data(){
            return {
                rightItems:[],
                isShowChangJianWenTi:false,
                isShowTips:false,
                isShowZiXunGuanYuan:false
            }
        },
        created(){
            this.isShowChangJianWenTi = this.base_url().isShowChangJianWenTi;
            this.isShowTips = this.base_url().isShowTips;
            this.isShowZiXunGuanYuan = this.base_url().isShowZiXunGuanYuan;
            if( this.isShowChangJianWenTi){
                this.rightItems.push({name:"常见问题",iconClass:'iconfont icon-wenhao',show:false,id:'cjwt'});
            }
            if(this.isShowTips){
                this.rightItems.push({name:"Tips",iconClass:'iconfont icon-xin',show:false,id:'tips'});
            }
            if(this.isShowZiXunGuanYuan){
                 this.rightItems.push({name:"咨询馆员",iconClass:'iconfont icon-taolunxuanzhong',show:false,id:'zxgy'});
            }
           
        },
        methods:{
            routerLink(item){
                this.$router.push({path:'/Content',query: {id: item.id}});
            },
            rightItemsHover(index,isHoverStart){
                let rightItems = this.rightItems;
                if(isHoverStart){
                    for(let i = 0;i<rightItems.length;i++){
                        if(i == index){
                            rightItems[i].show = true;
                            break;
                        }
                    }
                }else{
                    for(let i = 0;i<rightItems.length;i++){
                        if(i == index){
                            rightItems[i].show = false;
                            break;
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-width:768px){
        .right_items{
            display: none;
        }
    }
    @media screen and (min-width:768px){
        .right_items{
            position: absolute;
            top: 100px;
            right: 0;
            width: auto;
            height: auto;
            cursor:pointer;
        }
        .right_items .icon{
            position: relative;
            background: #fa695d;
            z-index: 1;
            width: 60px;
            height: 60px;
            border: solid 1px #fff;
            border-radius: 50%;
            cursor: pointer;
            float: right;
            text-align: center;
            line-height: 60px;
            color: #fff;
        }
        .right_items .icon .iconfont{
            font-size: 30px;
        }
        .right_items .r_item{
            position: relative;
            margin-bottom: 20px;
            display: block;
        }

        .right_items .r_item:nth-child(2) .icon,.right_items .r_item:nth-child(2) .text{
            background: #4ad5e9;
        }
        .right_items .r_item:nth-child(3) .icon,.right_items .r_item:nth-child(3) .text{
            background: #00c8b0;
        }
        .right_items .text{
            position: relative;
            height: 35px;
            width: 94px;
            border: solid 1px #fff;
            top: 13px;
            text-align: center;
            color: #fff;
            background: #fa695d;
            line-height: 35px;
            float: right;
            margin-left: -10px;
            font-weight: bold;
        }
    }
</style>